import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';
import { FileOpener } from '@ionic-native/file-opener/ngx';
import { File } from '@ionic-native/file/ngx';

import { TranslateModule } from '@ngx-translate/core';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { RecaptchaModule } from 'ng-recaptcha';

import { ComponentsLibModule } from '@arpada/arp-shared-comp-qupro';

import { IonicSelectableModule } from 'ionic-selectable';

import { PipesModule } from '../pipes/pipes.module';

import { SharedModule } from './shared/shared.module';

import { CsitesComponent } from './csites/csites.component';
import { CsiteComponent } from './csites/csite/csite.component';
import { CsiteEscritorioComponent } from './csites/csite-escritorio/csite-escritorio.component';
import { SelectorCsiteComponent } from './csites/selector-csite/selector-csite.component';

import { IssuesComponent } from './issues/issues.component';
import { IssueComponent } from './issues/issue/issue.component';
import { IssueEscritorioComponent } from './issues/issue-escritorio/issue-escritorio.component';

import { IssuesRepasosPreventaComponent } from './issues-repasos-preventa/issues-repasos-preventa.component';
import { IssueRepasosPreventaComponent } from './issues-repasos-preventa/issue-repasos-preventa/issue-repasos-preventa.component';
import { IssuesRepasosPreventaEscritorioComponent } from './issues-repasos-preventa/issues-repasos-preventa-escritorio/issues-repasos-preventa-escritorio.component';

import { IssuesProformablesComponent } from './issues-proformables/issues-proformables.component';
import { IssuesProformablesEscritorioComponent } from './issues-proformables/issues-proformables-escritorio/issues-proformables-escritorio.component';
import { IssueProformablesCardComponent } from './issues-proformables/issue-proformables-card/issue-proformables-card.component';
import { IssuesCrearProformablesEscritorioComponent } from './issues-proformables/issues-crear-proformables-escritorio/issues-crear-proformables-escritorio.component';
import { IssuesResumenProformaEscritorioComponent } from './issues-proformables/issues-resumen-proforma-escritorio/issues-resumen-proforma-escritorio.component';

import { IssuesMantenimientoComponent } from './issues-mantenimiento/issues-mantenimiento.component';
import { IssueMantenimientoEscritorioComponent } from './issues-mantenimiento/issue-mantenimiento-escritorio/issue-mantenimiento-escritorio.component';
import { IssueMantenimientoComponent } from './issues-mantenimiento/issue-mantenimiento/issue-mantenimiento.component';

import { ProformasComponent } from './proformas/proformas.component';
import { ProformaComponent } from './proformas/proforma/proforma.component';
import { ProformaEscritorioComponent } from './proformas/proforma-escritorio/proforma-escritorio.component';

import { ConformesComponent } from './conformes/conformes.component';
import { ConformeComponent } from './conformes/conforme/conforme.component';
import { ConformeEscritorioComponent } from './conformes/conforme-escritorio/conforme-escritorio.component';

import { HeaderComponent } from './header/header.component';
import { OpcionesPerfilComponent } from './header/opciones-perfil/opciones-perfil.component';

import { CambioPasswordComponent } from './cambio-password/cambio-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { PortalModalComponent } from './portal-modal/portal-modal.component';
import { SubirConformeComponent } from './conformes/subir-conforme/subir-conforme.component';

@NgModule({
  declarations: [
    HeaderComponent,
    PortalModalComponent,
    CambioPasswordComponent,
    ResetPasswordComponent,
    CsitesComponent,
    CsiteComponent,
    IssuesComponent,
    IssueComponent,
    ProformasComponent,
    ProformaComponent,
    ProformaEscritorioComponent,
    CsiteEscritorioComponent,
    IssueEscritorioComponent,
    IssuesRepasosPreventaComponent,
    IssuesRepasosPreventaEscritorioComponent,
    IssueRepasosPreventaComponent,
    OpcionesPerfilComponent,
    SelectorCsiteComponent,
    IssuesProformablesComponent,
    IssuesProformablesEscritorioComponent,
    IssueProformablesCardComponent,
    IssuesCrearProformablesEscritorioComponent,
    IssuesResumenProformaEscritorioComponent,
    IssuesMantenimientoComponent,
    IssueMantenimientoEscritorioComponent,
    IssueMantenimientoComponent,
    ConformesComponent,
    ConformeComponent,
    ConformeEscritorioComponent,
    SubirConformeComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    PipesModule,
    TranslateModule,
    RecaptchaModule,
    ComponentsLibModule,
    NgxDatatableModule,
    SharedModule,
    IonicSelectableModule,
  ],
  exports: [
    HeaderComponent,
    PortalModalComponent,
    CambioPasswordComponent,
    ResetPasswordComponent,
    CsitesComponent,
    IssuesComponent,
    ProformasComponent,
    IssuesRepasosPreventaComponent,
    IssuesProformablesComponent,
    IssuesMantenimientoComponent,
    ConformesComponent,
    SubirConformeComponent
  ],
  providers: [
    File,
    FileOpener
  ],
  entryComponents: [
    CambioPasswordComponent,
    PortalModalComponent,
    ResetPasswordComponent
  ]
})
export class ComponentsModule { }
